import React from 'react';
import EmbeddedMedia from '../EmbeddedMedia';
import SectionContainer from '../SectionContainer';
import ContentWrapper from '../ContentWrapper';

export default function MediaSection({ data }) {
  if (!data.images && !data.embeddedCodeSnippet) {
    return null;
  }

  // @HACK: Special check if the user is embedding the clutch-widget.
  // A style is added which is used to force the widget to display at full width
  const isClutchWidget =
    data.embeddedCodeSnippet?.embeddedCodeSnippet?.includes('clutch-widget');

  return (
    <SectionContainer
      backgroundColor={data.backgroundColor || 'gray'}
      className={`media-section ${isClutchWidget ? 'is-clutch-widget' : ''} ${
        data.caption ? 'is-captioned' : ''
      }`}
    >
      <ContentWrapper>
        <figure
          className={`media-section-container ${
            data.images?.length > 1 && !data.embeddedCodeSnippet ? 'flex' : ''
          }`}
        >
          <EmbeddedMedia data={data} fit="contain" />
          {data.caption ? <figcaption>{data.caption}</figcaption> : null}
        </figure>
      </ContentWrapper>
    </SectionContainer>
  );
}
